export const filterObjectsByNonEmptyKey = (objectsArray, key) => {
    if (!objectsArray) return []

    return objectsArray.filter(obj => {
        const value = obj[key];
        return value !== undefined && value !== null && value.toString().trim() !== '';
    });
}